import { ISetting } from '../../domain/models/ISettings';
import { SettingsRepository } from '../../domain/repositories/settings.repository';

export const settingsServices = (repository: SettingsRepository): SettingsRepository => ({
  getLinks: async (): Promise<ISetting[] | string> => {  
    return repository.getLinks();
  }
});
